import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BaseInfo from './components/list-detail.vue';
import PassInfo from './components/pass-info.vue';
import SonInfo from './components/son-info.vue';
let default_1 = class extends Vue {
};
default_1 = __decorate([
    Component({
        components: { BaseInfo, PassInfo, SonInfo },
        i18n: {
            messages: {
                'en-us': {},
                zh: {},
            },
        },
    })
], default_1);
export default default_1;
